import BaseService from "./BaseService";

export default class ScopeService extends BaseService {
  endPoint = "Scope";

  constructor(keycloakToken, currentScope = "") {
    super(keycloakToken, currentScope);
  }

  async GetHierarchyByScope(scope) {
    return this.get(`${this.endPoint}/GetHierarchyByScope/${scope}`);
  }
}
